// 다음 우편번호 스크립트 — 주소 검색을 누를 때만 한 번 싣는다(필로스 `daum-postcode-dialog` 에서 복사).

export const DAUM_POSTCODE_SRC = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

// 쓰는 칸만 — 전체 목록은 다음 우편번호 가이드의 oncomplete 결과.
export interface DaumPostcodeData {
  zonecode: string;
  roadAddress: string;
  autoRoadAddress?: string;
  jibunAddress: string;
  autoJibunAddress?: string;
  buildingCode: string;
  bcode: string;
}

interface DaumPostcodeOptions {
  width: string;
  height: string;
  maxSuggestItems?: number;
  oncomplete: (data: DaumPostcodeData) => void;
}

interface DaumPostcodeInstance {
  embed: (element: HTMLElement, options?: { autoClose?: boolean }) => void;
}

declare global {
  interface Window {
    daum?: { Postcode: new (options: DaumPostcodeOptions) => DaumPostcodeInstance };
  }
}

let loading: Promise<void> | null = null;

// 실패하면 붙인 태그를 떼고 약속을 비워 다음 클릭에서 다시 받는다(태그가 겹쳐 쌓이지 않게).
export const loadDaumPostcode = (): Promise<void> => {
  if (typeof window === "undefined") return Promise.reject(new Error("브라우저에서만 쓸 수 있습니다"));
  if (window.daum?.Postcode) return Promise.resolve();
  if (loading) return loading;
  const script = document.createElement("script");
  loading = new Promise<void>((resolve, reject) => {
    script.src = DAUM_POSTCODE_SRC;
    script.async = true;
    script.onload = () => (window.daum?.Postcode ? resolve() : reject(new Error("주소 검색을 불러오지 못했습니다")));
    script.onerror = () => reject(new Error("주소 검색을 불러오지 못했습니다"));
    document.head.appendChild(script);
  }).catch((error: unknown) => {
    script.remove();
    loading = null;
    throw error;
  });
  return loading;
};

export interface AddressPick {
  road: string;
  jibun: string;
  zonecode: string;
  bcode: string;
  buildingCode: string;
}

// 지번을 골라도 도로명을 보인다 — 비어 있으면 다음이 채워 주는 auto* 로 메운다.
export const toAddressPick = (data: DaumPostcodeData): AddressPick => ({
  road: data.roadAddress || data.autoRoadAddress || "",
  jibun: data.jibunAddress || data.autoJibunAddress || "",
  zonecode: data.zonecode ?? "",
  bcode: data.bcode ?? "",
  buildingCode: data.buildingCode ?? "",
});
